import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import twitter from '../assets/twitter.svg';
import heart from '../assets/heart.svg';

const links = [
  {
    label: 'About',
    href: '/about/',
  },
  {
    label: 'Book list',
    href: '/books/',
  },
  {
    label: 'Episode list',
    href: '/episodes/sort/',
  },
  {
    label: 'Categories',
    href: '/categories/',
  },
  {
    label: 'Stats',
    href: '/stats/',
  },
  {
    label: 'Articles',
    href: '/articles/',
  },
  {
    label: 'Schedule',
    href: '/schedule/',
  },
  {
    label: 'Random episode',
    href: '/random/',
  },
];

const Footer = () => {
  return (
    <div>
      <footer className="mt-12 mb-10 bg-gray-900 border-gray-600 rounded-sm">
        <div className="flex flex-col justify-center gap-2">
          <div>
            <div className="flex flex-wrap justify-center gap-4 md:gap-10 border-t border-gray-500">
              <ul className="border-l border-gray-500 pl-5 mt-2 flex flex-col">
                {links.map((item) =>
                  !item.href.startsWith('https') ? (
                    <Link
                      key={`footer-item-${item.label}`}
                      to={item.href}
                      className="text-gray-300 hover:text-white py-2 text-lg font-medium"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <a
                      key={`footer-item-${item.label}`}
                      href={item.href}
                      target="_blank"
                      rel="noreferrer"
                      className="text-gray-300 hover:text-white py-2 text-lg font-medium"
                    >
                      {item.label}
                    </a>
                  )
                )}
                <a
                  href="https://twitter.com/LFP_Library"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="py-2"
                >
                  <img
                    src={twitter}
                    alt="Twitter logo"
                    width="18"
                    className="inline"
                  />
                </a>
              </ul>
              <div className="self-center">
                <StaticImage
                  src="../assets/lfp.jpeg"
                  alt="Lex Fridman Podcast"
                  placeholder="blurred"
                  layout="constrained"
                  width={300}
                  className="rounded-md mt-3"
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-1 mt-2 p-2 text-lg self-center text-center">
            <span>
              Donate:{' '}
              <span className="text-hl">
                1BbVzfZ164GUrwKKrSifddxTFuoNfdJorJ
              </span>
            </span>
            <span>
              &copy; {new Date().getFullYear()} · LFP Library
              <br />
              Made with{' '}
              <img
                src={heart}
                alt="Heart"
                width="20"
                className="inline"
              /> by{' '}
              <a
                href="https://github.com/rsapkf"
                target="_blank"
                rel="noreferrer noopener"
              >
                rsapkf
              </a>
            </span>{' '}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
